/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { AlertConfigSelector } from '../../../../../redux/reducers/alertConfig/alertConfigReducer';

import './alertCheckbox.less'
import SquareCheckbox from './checkBox';
import { useTranslation } from 'react-i18next';
import { jsonData } from '../../../../constants/constants';

interface CheckboxProps {
    onChange: any;
    initialValue: any;
    name: string
    data: any
    onRevert: Function
    selectAll?: any
    onSelectCheckbox: Function
}

function SmsCheckbox(props: CheckboxProps) {
    const { t } = useTranslation()
    const { data, name } = props
    const [isChecked, setIsChecked] = useState<boolean>(false)
    const [isDisabled, setIsDisabled] = useState<boolean>(false)
    const { alertConfigChanges } = useSelector(AlertConfigSelector)

    useEffect(() => {
        if(alertConfigChanges[data?.eventId] && alertConfigChanges[data?.eventId][name] !== null && alertConfigChanges[data?.eventId][name] !== undefined){
            setIsChecked(alertConfigChanges[data?.eventId][name])
        }
        else{
            setIsChecked(props.initialValue)
        }
    }, [alertConfigChanges, props.initialValue])


    const onChange = () => {
        let value = !isChecked
        if(props?.initialValue === value){
            props.onRevert(data?.eventId, name)
        }
        else{
            props.onChange(data, { [name]: value})
        }
        // handle onSelectCheckbox
        props.onSelectCheckbox(data?.eventId, value)
        setIsChecked(value)
    }

    useEffect(() => {
        
        if(alertConfigChanges[data?.eventId]?.isActive === false){
            setIsDisabled(true)
        }
        else if(alertConfigChanges[data?.eventId]?.isActive === true){
            setIsDisabled(false)
        }
        else if(!data?.isActive && !isDisabled){
            setIsDisabled(true)
        }
        else if(data?.isActive && isDisabled){
            setIsDisabled(false)
        }
    }, [alertConfigChanges])

    return (
        <SquareCheckbox checkBoxName={t(jsonData.SMS)} onChange={isDisabled ? ()=>{} : onChange} className={isDisabled ? 'custom-checkboxDisable': ''} isChecked={isChecked ?? false}/>
    )
}

export default SmsCheckbox;